"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "setServerTimeDelta", {
  enumerable: true,
  get: function get() {
    return _setServerTimeDelta["default"];
  }
});
var _setServerTimeDelta = _interopRequireDefault(require("./setServerTimeDelta"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }